import React from 'react'
import { Typography } from '@mui/material'

const Subtitle = ({ uischema }) => {
    return (
        <Typography
            variant={'body2'}
            sx={{
                color: 'grey',
                marginBottom: '17px',
            }}
        >
            {' '}
            {uischema.text}{' '}
        </Typography>
    )
}
export default Subtitle
